exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/corrective-action-almaha-modal/corrective-action-almaha-modal.component.scss
// module id = ../../../../../src/app/corrective-action-almaha-modal/corrective-action-almaha-modal.component.scss
// module chunks = main